import { axios } from '@/utils/request'

const api = {
  param: '/basicdata/param',
  orderType: '/basicdata/orderType',
  pricesSpread: '/basicdata/pricesSpread',
}

export function selectParam (parameter) {
  return axios({
    url: api.param + '/selectParam',
    method: 'get',
    params: parameter
  })
}

export function saveParam (parameter) {
  return axios({
    url: api.param + '/saveParam',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getOrderTypeList (parameter) {
  return axios({
    url: api.orderType + `/getList/${parameter}`,
    method: 'get',
  })
}

export function getList (parameter) {
  return axios({
    url: api.pricesSpread + '/list',
    method: 'get',
  })
}

export function getSave (parameter) {
  return axios({
    url: api.pricesSpread + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const brandExport = api.brand + '/export'
